module.exports = __webpack_public_path__ + "chatbotinfost/webchat_static/media/fa-duotone-900.7bc112bc.woff";